import React, { lazy, Suspense } from "react";
import Loading from "./components/Loading/Loading";
import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { auth } from "./firebase/firebase.utilies";
import { onSnapshot } from "firebase/firestore";
import { profileDetails } from "./firebase/firebase.utilies";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "./redux/UserSlice/userSlice";
import {
  setAuthenticationToken,
  removeAuthenticationToken,
} from "./redux/Auth/AuthSlice";
import MerchantPage from "./pages/403/MerchantPage";
import UserPage from "./pages/403/UserPage";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/argon-dashboard.min.css";
import "./assets/css/nucleo-icons.css";
import "./assets/css/font-awesome.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const Dashboard = lazy(() => import("./pages/Dashboard/Dashboard"));
  const Overview = lazy(() => import("./pages/Dashboard/Overview/Overview"));
  const Orders = lazy(() => import("./pages/Dashboard/Orders/Orders"));
  const Pickup = lazy(() => import("./pages/Dashboard/Pickup/Pickup"));
  const Users = lazy(() => import("./pages/Dashboard/Users/Users"));
  const Merchants = lazy(() => import("./pages/Dashboard/Merchants/Merchants"));
  const Admin = lazy(() => import("./pages/Dashboard/Admin/Admin"));
  const DropPoints = lazy(() =>
    import("./pages/Dashboard/DropPoints/DropPoints")
  );
  const Rewards = lazy(() => import("./pages/Dashboard/Rewards/Rewards"));
  const Messages = lazy(() => import("./pages/Dashboard/Messages/Messages"));
  const ComposeMessage = lazy(() =>
    import("./pages/Dashboard/ComposeMessage/ComposeMessage")
  );
  const Profile = lazy(() => import("./pages/Dashboard/Profile/Profile"));
  const Login = lazy(() => import("./pages/Login/Login"));
  const ForgotPassword = lazy(() =>
    import("./pages/ForgotPassword/ForgotPassword")
  );
  const InitialChangePassword = lazy(() =>
    import("./pages/InitialChangePassword/InitialChangePassword")
  );
  const AddUser = lazy(() =>
    import("./pages/Dashboard/Users/AddUsers/AddUsers")
  );
  const Settings = lazy(() => import("./pages/Dashboard/Settings/Settings"));
  const AdminTools = lazy(() =>
    import("./pages/Dashboard/AdminTools/AdminTools")
  );
  const ConfirmPickup = lazy(() =>
    import("./pages/Dashboard/AdminTools/ConfirmPickup/ConfirmPickUp")
  );
  const UserProfile = lazy(() =>
    import("./pages/Dashboard/Users/UserProfile/UserProfile")
  );

  const dispatch = useDispatch();
  const [merchantRedirect, setMerchantRedirect] = useState(false);
  const [userRedirect, setUserRedirect] = useState(false);
  const { authenticatedToken } = useSelector((store) => store.authentication);
  const { signedUp } = useSelector((store) => store.signup);
  const { currentUser } = useSelector((store) => store.user);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    auth.onAuthStateChanged(async (userAuth) => {
      try {
        if (userAuth) {
          setLoading(true);
          auth.currentUser.getIdTokenResult().then((idTokenResult) => {
            if (idTokenResult.claims.merchant) {
              setMerchantRedirect(true);
              setLoading(false);
              return;
            }
            if (
              !idTokenResult.claims.administrator &&
              !idTokenResult.claims.superAdmin
            ) {
              setUserRedirect(true);
              setLoading(false);
              return;
            }
          });
          const currentProfile = await profileDetails(userAuth);
          onSnapshot(currentProfile, (snapShot) => {
            dispatch(setAuthenticationToken(snapShot.data().token));
            const data = snapShot.data();
            dispatch(setUser(data));
          });
          setLoading(false);
        } else {
          setLoading(false);
          dispatch(setUser(userAuth));
          dispatch(removeAuthenticationToken(userAuth));
        }
      } catch (err) {}
    });
  }, [signedUp]);

  if (loading) {
    return <Loading />;
  }

  if (merchantRedirect) {
    return <MerchantPage />;
  }

  if (userRedirect) {
    return <UserPage />;
  }

  if (authenticatedToken) {
    if (currentUser.initialPassword === null) {
      return <Loading />;
    }
  }

  return (
    <Routes>
      <Route
        path="/forgot-password"
        element={
          authenticatedToken ? (
            <Navigate to={"/"} />
          ) : (
            <Suspense fallback={<Loading />}>
              <ForgotPassword />
            </Suspense>
          )
        }
      />
      <Route
        path="/login"
        element={
          authenticatedToken ? (
            <Navigate to={"/"} />
          ) : (
            <Suspense fallback={<Loading />}>
              <Login />
            </Suspense>
          )
        }
      />
      <Route
        path="/"
        element={
          !authenticatedToken ? (
            <Navigate to={"/login"} />
          ) : !currentUser.initialPassword ? (
            <Suspense fallback={<Loading />}>
              <Dashboard />
            </Suspense>
          ) : (
            <Suspense fallback={<Loading />}>
              <InitialChangePassword />
            </Suspense>
          )
        }
      >
        <Route
          index
          path="/"
          element={
            <Suspense fallback={<Loading />}>
              <Overview />
            </Suspense>
          }
        />
        <Route
          path="/orders"
          element={
            <Suspense fallback={<Loading />}>
              <Orders />
            </Suspense>
          }
        />
        <Route
          path="/pickup"
          element={
            <Suspense fallback={<Loading />}>
              <Pickup />
            </Suspense>
          }
        />
        <Route
          path="/users"
          element={
            <Suspense fallback={<Loading />}>
              <Users />
            </Suspense>
          }
        />
        <Route
          path="/users/:userId"
          element={
            <Suspense fallback={<Loading />}>
              <UserProfile />
            </Suspense>
          }
        />
        <Route
          path="/add-user"
          element={
            <Suspense fallback={<Loading />}>
              <AddUser />
            </Suspense>
          }
        />
        <Route
          path="/merchants"
          element={
            <Suspense fallback={<Loading />}>
              <Merchants />
            </Suspense>
          }
        />
        <Route
          path="admin"
          element={
            <Suspense fallback={<Loading />}>
              <Admin />
            </Suspense>
          }
        />
        <Route
          path="/drop-points"
          element={
            <Suspense fallback={<Loading />}>
              <DropPoints />
            </Suspense>
          }
        />
        <Route
          path="/rewards"
          element={
            <Suspense fallback={<Loading />}>
              <Rewards />
            </Suspense>
          }
        />
        <Route
          path="/messages"
          element={
            <Suspense fallback={<Loading />}>
              <Messages />
            </Suspense>
          }
        />
        <Route
          path="/compose-message"
          element={
            <Suspense fallback={<Loading />}>
              <ComposeMessage />
            </Suspense>
          }
        />
        <Route
          path="/settings"
          element={
            <Suspense fallback={<Loading />}>
              <Settings />
            </Suspense>
          }
        />
        <Route
          path="/admin-tools"
          element={
            <Suspense fallback={<Loading />}>
              <AdminTools />
            </Suspense>
          }
        />
        <Route
          path="/confirm-pickup"
          element={
            <Suspense fallback={<Loading />}>
              <ConfirmPickup />
            </Suspense>
          }
        />
        <Route
          path="/profile"
          element={
            <Suspense fallback={<Loading />}>
              <Profile />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}

export default App;
